<template>
  <div
    class="charts-empty-state d-flex flex-column align-items-center justify-content-center h-100"
  >
    <div class="d-flex flex-column align-items-center justify-content-center">
      <div
        class="charts-empty-state__icon d-flex align-items-center justify-content-center"
      >
        <i-icon
          symbol="large-graph-2"
          :size="48"
          :colour="palette['light-primary-100']"
        ></i-icon>
      </div>
      <h5
        class="i-text-neutral-120 i-text-heading-5 i-mb-xs i-mt-10"
        data-testid="charts-empty-state-title"
      >
        {{ title }}
      </h5>
      <p
        v-if="description"
        data-testid="charts-empty-state-description"
        class="i-text-neutral-110 i-text-body-2 text-center i-mb-0"
        v-html="description"
      ></p>
    </div>
  </div>
</template>

<script>
import { iIcon } from '@inscribe/signal';
import palette from '@inscribe/signal/dist/palette';

export default {
  name: 'EmptyState',
  components: {
    'i-icon': iIcon,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      palette,
    };
  },
};
</script>

<style lang="scss" scoped>
.charts-empty-state__icon {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: $light-primary-30;
}

p {
  color: $light-neutral-110;
}
</style>
